<template>
  <div>
    <v-main>
      <v-sheet class="ml-0 ml-sm-12 mt-0 mt-sm-6 px-4 transparent">
        <template v-if="loading">
          <opq-loading size="200"></opq-loading>
        </template>
        <template v-else>
          <headline :code="'titre-' + service"></headline>
          <p v-for="(erreur, i) in erreurs" class="error--text mb-0" :key="'erreur-' + i">
            <v-icon color="error">mdi-alert-circle-outline</v-icon> {{ erreur }}
          </p>
          <v-row>
            <v-col cols="12" md="3">
              <v-sheet class="transparent">
                <h3 class="headline mb-6"><ressource code="recherche" hide-if-empty></ressource></h3>
                <FormulaireRecherche :recherche="recherche" :service="service"></FormulaireRecherche>
                <v-btn class="mb-3" color="primary" x-large @click="rechercher">Rechercher</v-btn>
              </v-sheet>
              <a @click="goToAutreService"><ressource :code="'consulter-' + service"></ressource></a>
            </v-col>

            <v-col cols="1" class="d-none d-md-flex text-center">
              <v-divider vertical class="mx-auto"></v-divider>
            </v-col>
            <v-col cols="12" md="7">
              <router-view
                id="recherche-resultats"
                :loading="resultatsLoading"
                :cartes-affaires-abregees="resultats"
                :details-connus="detailsConnus"
                @carte-affaire-selected="carteAffaireSelected"
                @go-to-results="goToResults"
              ></router-view>
            </v-col>
          </v-row>
        </template>
      </v-sheet>
    </v-main>
  </div>
</template>

<script>
import FormulaireBase from "@/mixins/FormulaireBase"
import FormulaireRecherche from "@/components/Repertoire/FormulaireRecherche"
import { rechercher, getDetails } from "@/plugins/services/repertoire"
import RechercheRepertoireModel from "@/models/RechercheRepertoireModel"
import AppbarBase from "@/mixins/AppbarBase"

export default {
  mixins: [FormulaireBase, AppbarBase],
  components: {
    FormulaireRecherche
  },
  props: {
    service: { type: String, required: true }
  },
  data() {
    return {
      resultats: undefined,
      detailsConnus: [],
      resultatsLoading: false,
      recherche: null,
      erreurs: []
    }
  },
  mounted() {
    this.recherche = new RechercheRepertoireModel()
    this.loadParams("recherche-repertoire")
  },
  watch: {
    service() {
      this.resultats = undefined
      this.recherche = new RechercheRepertoireModel()
      this.detailsConnus = []
      this.resultatsLoading = false
      this.erreurs = []
      this.$vuetify.goTo(0)
    }
  },
  computed: {
    serviceName() {
      if (this.service == "PS") {
        return "Psychologue"
      } else if (this.service == "PT") {
        return "Psychotherapeute"
      }
      return ""
    },
    autreServiceName() {
      if (this.service == "PS") {
        return "Psychotherapeute"
      } else if (this.service == "PT") {
        return "Psychologue"
      }
      return ""
    }
  },
  methods: {
    goToAutreService() {
      this.$router.push({ name: "RepertoireResultats" + this.autreServiceName, query: { ...this.$route.query } })
    },
    rechercher() {
      this.resultats = []
      this.erreurs = []
      this.resultatsLoading = true
      if (!this.$route.name.includes("Resultats")) {
        this.$router.push({ name: "RepertoireResultats" + this.serviceName, query: { ...this.$route.query } })
      }
      this.$vuetify.goTo("#recherche-resultats")
      rechercher(this.recherche, this.service)
        .then((res) => {
          if (res.data.estValide) {
            this.resultats = res.data.cartesAffairesAbregees
          } else {
            this.erreurs = res.data.erreurs
          }
        })
        .finally(() => {
          this.resultatsLoading = false
        })
    },
    async carteAffaireSelected(id) {
      if (!this.detailsConnus.find((d) => d.id == id)) {
        this.resultatsLoading = true

        let newDetail = await getDetails(id)
        this.detailsConnus.push(newDetail.data)
        this.resultatsLoading = false
      }
      if (!this.$route.name.includes("Details")) {
        this.$router.push({ name: "RepertoireDetails" + this.serviceName, params: { id }, query: { ...this.$route.query } })
      }
    },
    goToResults() {
      this.$router.push({ name: "RepertoireResultats" + this.serviceName, query: { ...this.$route.query } })
    }
  }
}
</script>

<style>
</style>